//  export const IMG_URL = "http://192.168.16.58:8080";
export const IMG_URL = "https://pstadmin.profcymadev.in/public/";

// export const IMG_URL = "https://mywealthwave.hostelbliss.com:4343";

export const Select2Data = async (data, name, other = false) => {
  const result = data.map((data) => ({
    value: data?.id,
    label: data?.name,
    name: name,
    image: data?.image,
  }));

  if (other) {
    result.push({ value: "0", label: "Other", name: name });
  }
  return result;
};

export function formatDate(dateString) {
  const date = new Date(dateString);

  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0"); // months are 0-based
  const year = date.getFullYear();

  return `${day}-${month}-${year}`;
}

// export const formatTime = (dateString) => {
//   if (!dateString) return "";

//   const date = new Date(dateString);

//   const hours = String(date.getHours()).padStart(2, "0");
//   const minutes = String(date.getMinutes()).padStart(2, "0");
//   const seconds = String(date.getSeconds()).padStart(2, "0");

//   return `${hours}:${minutes}:${seconds}`;
// };

export const formatTime = (dateString) => {
  if (!dateString) return "";
  return new Date(dateString).toLocaleTimeString("en-US", {
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  });
};

export const FixIDS = {
  Roles: { List: 1, Add: 2, Edit: 3, Delete: 4 },
  Users: { List: 5, Add: 6, Edit: 7, Delete: 8 },
  Country: { List: 9, Add: 10, Edit: 11, Delete: 12 },
  State: { List: 13, Add: 14, Edit: 15, Delete: 16 },
  City: { List: 17, Add: 18, Edit: 19, Delete: 20 },
  Pincode: { List: 21, Add: 22, Edit: 23, Delete: 24 },
  Privacy_and_Policy: { List: 25, Add: 26, Edit: 27, Delete: 28 },
  Terms_and_Conditions: { List: 29, Add: 30, Edit: 31, Delete: 32 },
  Blog: { List: 33, Add: 34, Edit: 35, Delete: 36 },
  Category: { List: 37, Add: 38, Edit: 39, Delete: 40 },
  Social_Link: { List: 41, Add: 42, Edit: 43, Delete: 44 },
  Our_Team: { List: 45, Add: 46, Edit: 47, Delete: 48 },
  Testimonial: { List: 49, Add: 50, Edit: 51, Delete: 52 },
  Trust_And_Safety: { List: 53, Add: 54, Edit: 55, Delete: 56 },
  Faq: { List: 57, Add: 58, Edit: 59, Delete: 60 },
  Help_Category: { List: 61, Add: 62, Edit: 63, Delete: 64 },
  Help_Question: { List: 65, Add: 66, Edit: 67, Delete: 68 },
  App_Setup: { List: 69, Edit: 70 },
  Volunteer_Mode: { List: 71, Add: 72, Edit: 73, Delete: 74 },
  Volunteer_Detail: { List: 75, Edit: 76 },
  Gallery_Category: { List: 77, Add: 78, Edit: 79, Delete: 80 },
  Gallery_Images: { List: 81, Add: 82, Edit: 83, Delete: 84 },
  Contact_Us: { List: 85 },
  Article: { List: 86, Add: 87, Edit: 88, Delete: 89 },
  Fund_Raise: { List: 90, Add: 91, Edit: 92, Delete: 93 },
};
